import React, { useEffect } from 'react'
import AdditionalSalesGrid from './AdditionalSalesGrid'
import { ADDITIONAL_SALES_DETAIL_VIEW_TIMEOUT } from '../../utils/constantes'

const AdditionalSalesDetail = ({
  additionalSales,
  backgroundSrc,
  isOpen,
  onClose,
  onThemeClick,
  themeSplashOpen,
  resetTimerKey,
}) => {
  useEffect(() => {
    if (!isOpen || themeSplashOpen) return undefined

    const timeout = setTimeout(() => {
      onClose()
    }, ADDITIONAL_SALES_DETAIL_VIEW_TIMEOUT)

    return () => clearTimeout(timeout)
  }, [isOpen, onClose, resetTimerKey, themeSplashOpen])

  return (
    <div
      className="additionalSalesContainer additionalSalesDetailPopup"
      style={{
        opacity: isOpen ? 1 : 0,
        pointerEvents: isOpen ? 'auto' : 'none',
      }}
    >
      {backgroundSrc && <img src={backgroundSrc} alt="Background" className="background-image" />}
      <div className="head" />
      <AdditionalSalesGrid additionalSales={additionalSales} onThemeClick={onThemeClick} />
    </div>
  )
}

export default AdditionalSalesDetail
